<script>
  import { csv } from 'd3-fetch';
  import {gardenData} from '../../../stores';
  import Photos from '../../Photos.svelte';
  import { t,__ } from '../../../utils/i18n';
  import { gardens } from '../../../utils/copy';
 



let showAll = false;
function onToggle() {
  showAll = !showAll;
}

//yoinked from RepTablePrint.svelte
const dashedPhoneNumber = (d) => {
    // following ap style, returns xxx-xxx-xxxx
    // just in case, remove everything that is not a number first
    let cleanNumber = String(d).replace(/\D/g, '');
    let formattedNumber =
      '(' +
      cleanNumber.slice(0, 3) +
      ') ' +
      cleanNumber.slice(3, 6) +
      '-' +
      cleanNumber.slice(6);
    return String(formattedNumber);
  };

  </script>
  
  <div class="icard gardens">
    <div class="header">
      <p class="label">🌿 {__("Community gardens")}</p>
    </div>

    <div class="complex" class:show-more={showAll}> 
    {#if $gardenData.length > 0}
      <Photos
      lookup='potted_plant'
      className = "plant"
      idName = "potted_plant"
      ariaHidden = "false"
      lazyLoad = "false"
      />
        <!-- <p>Did you know you could grow your own tomatoes even if you don't have your own garden? That's what community gardens are for! Read all about what community gardens can offer – including classes, tools and more – <a href="https://www.latimes.com/california/story/2023-08-25/how-to-join-a-community-garden-in-la-county">in our guide</a>.</p> -->
        <p>
          {@html t(gardens, 'guide', '') }
        </p>
        <p class="subhed numbered-list-label">
          <span class="label">{__("Your nearby gardens")}</span>
        </p>
        <ol>
        {#each $gardenData as g,i}
          <li class="numbered-list">
            <!-- <p class="numbered-list"> -->
              <p>
                <!-- <span class="number-style" aria-hidden="true">{i+1}</span>  -->
                <span class="name-style">{g.name}</span>
            </p>
            {#if g.phone !== "" && g.email == "" && g.form == ""} 
              <!-- <p>Located at {g.address}. You can learn more by calling <a href="tel:+{g.phone}">{dashedPhoneNumber(g.phone)}</a>. {#if g.site !== ""}&nbsp;You can also check out the <a href="{g.site}">latest updates from the garden</a>.{/if}</p>  -->
              <p>
                {@html t(gardens, 'phone', {
                  'g.address': g.address,
                  'g.phone': dashedPhoneNumber(g.phone),
                })}
                {#if g.site !== ""}
                <!-- &nbsp;You can also check out the <a href="{g.site}">latest updates from the garden</a>. -->
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p>
            {:else if g.email !== "" && g.phone == "" && g.form == ""} 
              <p>
                {@html t(gardens, 'email', {
                  'g.address': g.address,
                  'g.email': g.email,
                })}
                {#if g.site !== ""}
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p>
            {:else if g.form !== "" && g.phone == "" && g.email == ""} 
              <p>
                {@html t(gardens, 'form', {
                  'g.address': g.address,
                  'g.form': g.form,
                })}
                {#if g.site !== ""}
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p> 
            {:else if g.phone !== "" && g.email !== "" && g.form !== ""} 
              <p>
                {@html t(gardens, 'all', {
                  'g.address': g.address,
                  'g.phone': dashedPhoneNumber(g.phone),
                  'g.email': g.email,
                  'g.form': g.form,
                })}
                {#if g.site !== ""}
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p>
            {:else if g.phone !== "" && g.email !== "" && g.form == ""} 
              <p>
                {@html t(gardens, 'phoneEmail', {
                  'g.address': g.address,
                  'g.phone': dashedPhoneNumber(g.phone),
                  'g.email': g.email,
                })}
                {#if g.site !== ""}
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p>
            {:else if g.phone !== "" && g.email == "" && g.form !== ""} 
              <p>
                {@html t(gardens, 'phoneForm', {
                  'g.address': g.address,
                  'g.phone': dashedPhoneNumber(g.phone),
                  'g.form': g.form,
                })}
                {#if g.site !== ""}
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p>
            {:else if g.phone == "" && g.email !== "" && g.form !== ""} 
              <p>
                {@html t(gardens, 'emailForm', {
                  'g.address': g.address,
                  'g.email': g.email,
                  'g.form': g.form,
                })}
                {#if g.site !== ""}
                {@html t(gardens, 'site', {
                  'g.site': g.site,
                })}
                {/if}
              </p>
            {/if}
          </li>
        {/each}
        </ol>
        <p style="font-size: 0.9rem">{@html t(gardens, 'availability', '') }</p>
      {:else}
        <!-- <p>Did you know you could grow your own tomatoes even if you don't have your own garden? That's what community gardens are for! Read all about what community gardens can offer – including classes, tools and more – <a href="https://www.latimes.com/california/story/2023-08-25/how-to-join-a-community-garden-in-la-county">in our guide</a>.</p> -->
        <p>
          {@html t(gardens, 'guide', '') }
        </p>
        <p>
          {@html t(gardens, 'startOne', '') }
        </p>
      {/if}
      <button class="showbtn btn action" on:click={onToggle}>
        {showAll ? __('Show less') : __('See nearby community gardens')}
      </button>
    </div>
  </div>
  
